export default "__VITE_ASSET__CRxMSR_Q__"